import { irrigacao } from './genericos'

const SAF = {
  area: '',
  dataInicio: '',
  especies: [],
  utilizaBioinsumos: '',
  possuiIrrigacao: '',
  financiamentos: [],
  outroFinanciamento: '',
  descricao: '',
  bioinsumos: [],
  irrigacao: {...irrigacao}

}

export default SAF



// WEBPACK FOOTER //
// ./src/libs/models/cadastro/praticas/SAF.js